import { render, staticRenderFns } from "./PoTransactionDataMobile.vue?vue&type=template&id=33d83a2e&"
import script from "./PoTransactionDataMobile.vue?vue&type=script&lang=js&"
export * from "./PoTransactionDataMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports